import React from 'react';
import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';

import Box from './Box';
import Icon, { ICON_OVERRIDE_KEYS } from './Icon';
import Heading from './Heading';
import Flex from './Flex';

const Callout = React.forwardRef(({ title, textAlign, intent, icon, className, children, ...rest }, ref) => {
  // HACK: partially override blueprint styling to fix positioning when icon is NOT a blueprint icon
  const iconStyling = {};
  if (typeof icon === 'function' || ICON_OVERRIDE_KEYS.has(icon)) {
    iconStyling.ml = '-5px';
    iconStyling.mt = '-7px';
  }

  return (
    <Box
      className={classNames(Classes.CALLOUT, className, {
        [Classes.intentClass(intent)]: intent,
        [Classes.CALLOUT_ICON]: icon
      })}
      style={{ textAlign }}
      ref={ref}
      {...rest}
    >
      {icon && <Icon icon={icon} />}

      <Flex flexDirection="column" gap="4px" flex={1}>
        {title && (
          <Heading m={0} level={5}>
            {title}
          </Heading>
        )}

        <div className="bp4-callout-text">{children}</div>
      </Flex>
    </Box>
  );
});

export default Callout;
